import utils from './../../utils.js';

export default utils.generateNamespace({
    state: [
        'AVAILABLE_JIRA_VALUES',
        'AVAILABLE_TFS_VALUES',
        'LOADER_VISIBLE',
        'SELECTED_JIRA_FIELD',
        'SELECTED_TFS_FIELD',
        'MAPPINGS_GROUPS'
    ],
    actions: [
        'SET_UP_SERVICE', 
        'GET_AVAILABLE_VALUES',
        'MAP',
        'REMOVE_MAPPING',
        'HANDLE_ERROR',
        'SET_SELECTED_JIRA_FIELD',
        'SET_SELECTED_TFS_FIELD',
        'SET_DEFAULT_MAPPING'
    ],
    mutations: [
        'SHOW_LOADER', 
        'SET_MAPPINGS_VALUES',
        'SET_SELECTED_JIRA_FIELD',
        'SET_SELECTED_TFS_FIELD',
        'UPDATE_MAPPINGS'
    ],
    getters: [
        'TFS_VALUES',
        'JIRA_VALUES',
        'MAPPINGS_GROUPS',
        'IS_LOADER_VISIBLE',
        'SELECTED_JIRA_FIELD',
        'SELECTED_TFS_FIELD'
    ],
    kinds: {
        JIRA: 'JIRA',
        TFS: 'TFS'
    }
});



// WEBPACK FOOTER //
// ./src/store/modules/fieldsMapping/namespace.js